import { ERROR_CODES } from '@/model/ErrorCodes'
import { Commit } from 'vuex'

export interface JoinState {
  result: GD_tournaments.JoinResult
}

const state: JoinState = {
  result: {
    success: false,
    reason: null,
  },
}

export const mutations = {
  result(state: JoinState, joinResult: GD_tournaments.JoinResult) {
    state.result = joinResult
  },
}

export const actions = {
  registerForTournament({ commit }: { commit: Commit }, tournamentId: string) {
    return fetch(process.env.VUE_APP_REST_URL + 'join/' + tournamentId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-cache',
    })
      .then((res: Response) => {
        if (res.status >= 400) {
          commit('error', { id: 'registerForTournament', responseStatus: res.status }, { root: true })
          throw { errorCode: res.status === 401 ? ERROR_CODES.UNAUTHORIZED : ERROR_CODES.UNKNOWN }
        }
        return res.json()
      })
      .then((data: GD_tournaments.JoinResult) => {
        commit('result', data)
      })
  },
}

export const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
